import {
    Box,
    Typography,
} from '@mui/material'
import { Image } from 'antd'
import OurExtensiveBanner from '../../../assets/about-us/our-extensive-banner.png'
import { useTranslation } from 'react-i18next'

export const SMAppOurExtensive: React.FC = () => {
    const { t } = useTranslation()

    // ======================= VIEWS
    return (
        <Box
            sx={{
                width: '100%',
                display: 'flex',
                flexDirection: 'column',
                paddingLeft: '12px',
                paddingRight: '12px',
                paddingTop: '55px',
                alignItems: 'center',
                backgroundColor: '#FFFFFF',
            }}
        >

            <Box>
                <Image src={OurExtensiveBanner} alt='' style={{ objectFit: 'cover', borderRadius: '10px' }} preview={false}></Image>
            </Box>

            <Box sx={{
                flex: '1',
                display: 'flex',
                flexDirection: 'column',
                paddingLeft: '12px',
                paddingRight: '12px',
            }}>
                <Typography fontSize={24} fontWeight={700} color={'#141F39'} paddingTop={'20px'}>
                    {t('t105')}
                </Typography>

                <Typography fontSize={16} fontWeight={400} color={'#6B6B6B'} paddingTop={'30px'}>
                    {t('t106')}
                </Typography>

                <Typography fontSize={16} fontWeight={400} color={'#6B6B6B'} paddingTop={'30px'}>
                    {t('t107')}
                </Typography>

            </Box>
        </Box>
    )
}

// ======================= EXPORT
export default SMAppOurExtensive
